export default "__VITE_ASSET__4dc91db5__"